import { http } from "api/http";

const getClientCategories = () => {
  return http.get("/client-categories");
};

const getClientCategory = ({ queryKey }: any) => {
  return http.get(
    `/client-categories/category/${queryKey[1]}`
  );
};

const getDefaultClientCategories = () => {
  return http.get(
    "/client-categories/default"
  );
};

const createClientCategory = (
  data: any,
) => {
  return http.post(
    "/client-categories",
    data,
  );
};

const createClientSubCategory = (
  data: any,
) => {
  return http.post(
    "/client-categories/add-sub-category",
    data,
  );
};

const deleteClientCategory = (
  id: any,
) => {
  return http.delete(
    `/client-categories/${id?.id}`,
  );
};

const deleteClientSubCategory = (
  id: any,
) => {
  return http.delete(
    `/client-categories/sub-category/${id?.id}`,
  );
};

const updateClientCategory = ({
  id,
  data,
}: {
  id: number;
  data: any;
}) => {
  return http.put(
    `/client-categories/${id}`,
    data,
  );
};

const updateClientSubCategory = ({
  id,
  data,
}: {
  id: number;
  data: any;
}) => {
  return http.put(
    `/client-categories/sub-category/${id}`,
    data,
  );
};

export {
  getClientCategories,
  getClientCategory,
  getDefaultClientCategories,
  createClientCategory,
  createClientSubCategory,
  deleteClientCategory,
  deleteClientSubCategory,
  updateClientCategory,
  updateClientSubCategory,
};